import Project from 'actions/project';

export default Project.createReducer();